<app-loader [isLoading]="isLoading"></app-loader>

@if(showAddForm) {
<!-- Form View -->
<div class="header form-header">
  <div class="top">
    <button (click)="cancelForm()" class="back-button">
      <h3>Incorporaciones /</h3>
      <div class="breadcrumb">
        <mat-icon svgIcon="arrow back"></mat-icon>
        <h2>
          {{ isEditMode ? "Editar incorporación" : "Añadir incorporación" }}
        </h2>
      </div>
    </button>
  </div>
</div>

<div class="content form">
  <form [formGroup]="incorporationForm">
    <h4>Título:</h4>
    <mat-form-field id="title-form-field" appearance="outline" [class.mat-form-field-invalid]="
        incorporationForm.get('title')?.invalid &&
        incorporationForm.get('title')?.touched
      ">
      <input type="text" matInput placeholder="Título" formControlName="title" />
      @if (incorporationForm.get('title')?.hasError('required')) {
      <mat-error> El título es obligatorio </mat-error>
      }
    </mat-form-field>

    <h4>Contenido:</h4>
    <quill-editor formControlName="content" [modules]="modules" [styles]="{ height: '300px' }"></quill-editor>
    @if (incorporationForm.get('content')?.invalid &&
    incorporationForm.get('content')?.touched) {
    <div class="error-message">El contenido es obligatorio</div>
    }

    <h4>Tipo:</h4>
    <mat-form-field appearance="outline">
      <mat-select formControlName="toppings">
        @for (topping of toppingList; track topping) {
        <mat-option [value]="topping">{{ topping }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </form>

  <br />
  <mat-checkbox [(ngModel)]="notifications">Notificaciones</mat-checkbox>
  <br />
  <mat-checkbox [(ngModel)]="isProgrammed">Programada</mat-checkbox>

  @if (isProgrammed) {
  <br /><br /><br />
  <mat-form-field appearance="outline" style="width: 16%; margin-right: 10px">
    <mat-label>Fecha</mat-label>
    <input matInput [matDatepicker]="datepicker" [(ngModel)]="dateValue" />
    <mat-datepicker #datepicker />
    <mat-datepicker-toggle [for]="datepicker" matSuffix />
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Hora</mat-label>
    <input matInput type="time" [(ngModel)]="timeValue" />
    <mat-icon matSuffix>access_time</mat-icon>
  </mat-form-field>

  <p>Fecha y hora programada: {{ getFormattedDateTime() }}</p>
  <br />
  }

  @if(!isEditMode || (isEditMode && !element?.image_url) ){
  <h4>Imagen:</h4>
  <app-upload-files [singleFile]="true" (filesSelected)="onFileSelected($event)"></app-upload-files>
  <br />
  } @else{
  <div class="media-header">
    <h4>Imagen actual:</h4>
  </div>
  <div class="existing-media">
    <div class="media-item">
      <div class="image-container">
        <img [src]="element?.image_url" alt="Incorporation image" class="media-preview">
        <button mat-icon-button color="warn" type="button" (click)="removeImage()" class="delete-image-btn">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
      <div class="media-info">
        <p>{{element?.image_url.split('/').pop() || 'Imagen de la incorporación'}}</p>
      </div>
    </div>
  </div>
  }
  <div class="buttons">
    <button mat-flat-button id="action" (click)="saveChanges()">
      {{ isEditMode ? "Actualizar" : "Guardar cambios" }}
    </button>
    <button mat-flat-button id="cancel" (click)="cancelForm()">Cancelar</button>
  </div>
</div>

} @else {
<!-- List View -->
<div class="header">
  <app-title [title]="title" [subtitle]="subtitle"></app-title>
  @if(myroles.can_write){
  <div class="top">
    <div class="boton">
      <button class="b1" mat-button (click)="addIncorporate()">
        Añadir incorporación
      </button>
    </div>
  </div>
  }
</div>

<div class="content list-view">
  <div class="filter">
    <div class="left-section">
      <div class="search-section">
        <mat-form-field appearance="outline" id="toppings">
          <mat-label>Tipo</mat-label>
          <mat-select [formControl]="toppings" multiple>
            @for (topping of toppingList; track topping) {
            <mat-option [value]="topping">{{ topping }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" id="toppings">
          <mat-label>Programación</mat-label>
          <mat-select [formControl]="programmed" multiple>
            @for (program of programmedList; track program) {
            <mat-option [value]="program">{{ program }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="filter-buttons">
        @for (filter of filters; track filter.value){
        <button [class.active]="selectedFilter === filter.value" (click)="selectFilter(filter.value)">
          {{ filter.label }}
        </button>
        }
      </div>
    </div>
    <div class="paginator-container">
      <mat-paginator [pageSizeOptions]="[25, 50, 100]" aria-label="Select page of the relation table"
        class="paginator-field">
      </mat-paginator>
    </div>
  </div>

  <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)"
    class="mat-elevation-z8 table">
    <!-- Columna de Título -->
    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef>TÍTULO</th>
      <td mat-cell *matCellDef="let element">
        <span style="font-size: 16px">{{ element.title | mailTitle }}</span>
      </td>
    </ng-container>

    <!-- Columna de Autor -->
    <ng-container matColumnDef="author">
      <th mat-header-cell *matHeaderCellDef>AUTOR</th>
      <td mat-cell *matCellDef="let element">
        <span style="font-size: 16px">{{
          element.employee_external_id | qeqPipe
          }}</span>
      </td>
    </ng-container>

    <!-- Columna de ID -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell *matCellDef="let element">
        <span style="font-size: 16px">{{ element.employee_external_id }}</span>
      </td>
    </ng-container>

    <!-- Columna de Tipo -->
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>TIPO</th>
      <td mat-cell *matCellDef="let element">
        @if(element.addition_type === 'Incorporación'){
        <button mat-flat-button id="consumed">
          <mat-icon matTextPrefix>check_circle</mat-icon>
          <span style="font-size: 16px">Incorporación</span>
        </button>
        }@else if (element.addition_type === 'Desvinculación') {
        <button mat-flat-button id="non-consumed">
          <mat-icon matTextPrefix>cancel</mat-icon>
          <span style="font-size: 16px">Desvinculación</span>
        </button>
        }@else{
        <button mat-flat-button id="reservation">
          <mat-icon matTextPrefix svgIcon="pending"></mat-icon>
          <span style="font-size: 16px">Cambios</span>
        </button>
        }
      </td>
    </ng-container>

    <!-- Columna de Publicación -->
    <ng-container matColumnDef="published-date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>PUBLICACIÓN</th>
      <td mat-cell *matCellDef="let element">
        @if(element.programmed){
        <button mat-flat-button id="button">
          <mat-icon matTextPrefix svgIcon="clock" style="transform: scale(1); left: 3px"></mat-icon>
          <span style="font-size: 16px">{{
            element.publication_date | customPipe
            }}</span>
        </button>
        }@else{
        <button mat-flat-button id="button">
          <span style="font-size: 16px">{{
            element.publication_date | customPipe
            }}</span>
        </button>
        }
      </td>
    </ng-container>

    <!-- Columna de Fecha de notificaciones -->
    <ng-container matColumnDef="notifications">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>NOTIFICACIONES</th>
      <td mat-cell *matCellDef="let element">
        @if(element.notifications){
        <button mat-flat-button id="button">
          <span style="font-size: 16px">Sí</span>
        </button>
        }@else{
        <button mat-flat-button id="button">
          <span style="font-size: 16px">No</span>
        </button>
        }
      </td>
    </ng-container>

    <!-- Columna de Acciones -->
    <ng-container matColumnDef="acciones">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        @if (myroles.can_write) {
        <button mat-icon-button class="acciones" (click)="goToMail(element)">
          <mat-icon svgIcon="edit"></mat-icon>
        </button>
        } @if (myroles.can_delete) {
        <button mat-icon-button class="acciones" (click)="deleteSelected(element.id, element.title)">
          <mat-icon svgIcon="delete"></mat-icon>
        </button>
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
}